import React from "react";
import KioskStartButton from "../components/start-button";

export default function PlacePackageScreen({ navigate, setInputWeight }) {
  return (
    <div className="flex flex-col items-center justify-between w-full h-full relative">
      <p className="text-[80px] text-white text-center mt-[10vh]">
        Place your trade-in <br /> package on the scale
      </p>

      <div className="grid grid-cols-2 gap-[36px] px-[3vh] relative z-10 mb-[3vh]">
        <KioskStartButton
          onClick={() => {
            setInputWeight(0);
            navigate("holding");
          }}
          icon="close"
        >
          Cancel
        </KioskStartButton>

        <KioskStartButton
          className="font-semibold"
          onClick={() => {
            navigate("weightDisplay");
          }}
          icon="arrow_forward"
          iconColor="black"
          color="yellow"
        >
          Continue
        </KioskStartButton>
      </div>
    </div>
  );
}
